// extracted by mini-css-extract-plugin
export default {"popover-wrapper":"_2W0ve","popoverWrapper":"_2W0ve","root":"_3GZPv"};